import React, { Component } from "react";
import Chart from "react-apexcharts";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import "./style.scss"
class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartType: "single",
    };
  }

  extractAirline = () => {
    const { barCharData } = this.props;
    return barCharData ? barCharData.map((item) => item.Name) : [];
  };

  extractPassengers = () => {
    const { barCharData } = this.props;
    return barCharData ? barCharData.map((item) => item.TotalPassengers) : [];
  };

  formatChartData(barCharData) {
    if (!barCharData || !Array.isArray(barCharData)) {
      return [];
    }

    const passengerTypes = ["Adult", "Child", "Infant"];
    const colors = ["#456EFF", "#FF7245", "#FFB200"]; // Define colors for each series

    return passengerTypes.map((type, index) => {
      const data = barCharData.map((carrier) => {
        const breakdown = carrier.Breakdown.find(
          (item) => item.PaxType === type
        );
        return breakdown ? breakdown.Count : 0;
      });

      return {
        name: type,
        data,
        color: colors[index], // Assign color to the series
      };
    });
  }

  toggleChartType = (type) => {
    this.setState({ chartType: type });
  };

  render() {
    const { title, barCharData } = this.props;
    const { chartType } = this.state;

    const series = [
      {
        name: "avicollect-chart",
        data: [...this.extractPassengers()],
      },
    ];

    const multipleSeries = this.formatChartData(barCharData);

    const options = {
      chart: {
        id: "avicollect-chart",
      },
      xaxis: {
        categories: [...this.extractAirline()],
      },
      dataLabels: {
        enabled: false, // Hide the value of the bars
      },
    };

    return (
      <Card className="pb-3" style={{ backgroundColor: "#FBFBFB" }}>
        <CardBody>
          <CardTitle className={"text-left pb-4"}>{title}</CardTitle>
          <div
            style={{
              marginTop: "-20px",
              marginBottom: "20px",
            }}
          >
             <Button
              // className={this.state.chartType === "single" ? "activeButton" : ""}
              style={{
                border: "none",
                borderRadius: "20px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "8px",
                backgroundColor: chartType === "single" ? "#b2b2b2" : "transparent",
              }}
              onClick={() => this.toggleChartType("single")}
            >
              Generic
            </Button>
            <Button
                // className={this.state.chartType === "multiple" ? "activeButton" : ""}
              style={{
                border: "none",
                borderRadius: "20px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "8px",
                backgroundColor: chartType === "multiple" ? "#b2b2b2" : "transparent",
              }}
              onClick={() => this.toggleChartType("multiple")}
            >
              Breakdown
            </Button>
           
          </div>
          <div
            className="chart-wrapper"
            style={{
              margin: "0 auto",
              height: 315,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Chart
              options={options}
              series={chartType === "single" ? series : multipleSeries}
              type="bar"
              width={400}
              height={320}
            />
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/bar-chart.js